import { classes } from './Constants';

export default class ADA {

  constructor(el) {
    this.classes = classes;
    this.$el = $(el);
    this.dom = {
      $swiperBanner: this.$el.find(`.${this.classes.swiperBanner}`),
      $swiperBannerContent: this.$el.find(`.${this.classes.swiperBannerContent}`),
    };
    this.attribute = {
      tabindex: 'tabindex',
    };
  }
  /* ADA Section */

  initADA() {
    const $initActiveSlide = this.dom.$swiperBannerContent.find(`.${this.classes.bannerItem}.swiper-slide-active`);
    this.setTabIndexNegativeForUnActiveSlide($initActiveSlide);
    this.focusNextPrevButton();
    this.disableTabindexDots();
  }

  focusNextPrevButton() {
    const $nextButton = this.$el.find(`.${this.classes.swiperButtonNext}`);
    const $prevButton = this.$el.find(`.${this.classes.swiperButtonPrev}`);

    $nextButton.on('focusin hover', () => {
      this.dom.$swiperBanner.addClass(this.classes.hoverNext);
      this.$el.addClass(this.classes.focusNext);
    }).on('focusout click', () => {
      this.dom.$swiperBanner.removeClass(this.classes.hoverNext);
      this.$el.removeClass(this.classes.focusNext);
    });

    $prevButton.on('focusin hover', () => {
      this.dom.$swiperBanner.addClass(this.classes.hoverPrev);
      this.$el.addClass(this.classes.focusPrev);
    }).on('focusout click', () => {
      this.dom.$swiperBanner.removeClass(this.classes.hoverPrev);
      this.$el.removeClass(this.classes.focusPrev);
    });
  }

  setTabIndexNegativeForUnActiveSlide($activeSlide) {
    const $bannerContentItems = this.$el.find(`.${this.classes.swiperBannerContent}`).find(`.${this.classes.bannerItem}`);
    const $unActiveSlide = $bannerContentItems.not($activeSlide);
    const $tabElements = $unActiveSlide.find('a, button, input');
    $tabElements.attr(this.attribute.tabindex, '-1');
  }

  setTabIndexPositiveForActiveSlide($activeSlide) {
    const $tabElements = $activeSlide.find('a, button, input');
    $tabElements.removeAttr(this.attribute.tabindex);
  }

  disableTabindexDots () {
    const $dots = this.$el.find(`.${this.classes.swiperPagination}`).find('[tabindex]');
    $dots.attr(this.attribute.tabindex, '-1');
  }
  /* End ADA Section */
}